/** The kinds `ItemEditForm` has a form for, with the text prefix of each. */
export const EDIT_FORMS = {
  step: { texts: "authoring.step" },
  label_list: { texts: "authoring.labelList" },
  artifact: { texts: "authoring.artifact" },
  capability_overrides: { texts: "authoring.capabilities" },
} as const;

export type EditFormKind = keyof typeof EDIT_FORMS;

export function hasEditForm(kind: string | undefined): kind is EditFormKind {
  return kind !== undefined && kind in EDIT_FORMS;
}
